import type { COLOR } from '@george-labs.com/design-system/types/utilsTS/color';

import { createWritableGenericContext } from '@luna/context';

export const { createContextProvider: createGlobalColorProvider, useContext: useGlobalColor } =
    createWritableGenericContext<COLOR | undefined>('globalColor');
